import { replaceEqualDeep } from "@tanstack/react-query";

const transientCodes = new Set([
  "NETWORK_UNREACHABLE",
  "INTERNAL_ERROR",
  "PROVIDER_UNAVAILABLE",
  "RATE_LIMITED",
]);
type Envelope = { data?: unknown; error?: { code?: string } | null };
/** Preserve the last scoreboard on a transient failure, while keeping the error recorded.
 * React Query invokes this only within one query key, never across games/days/zones. */
export function retainScoreData(previous: unknown, incoming: unknown): unknown {
  const old = previous as Envelope | undefined;
  const next = incoming as Envelope | undefined;
  if (
    old?.data != null &&
    next?.data == null &&
    transientCodes.has(next?.error?.code ?? "")
  ) {
    return { ...next, data: old.data };
  }
  return replaceEqualDeep(previous, incoming);
}

export const scoreQueryOptions = {
  structuralSharing: retainScoreData,
  refetchIntervalInBackground: false,
};

/** Keep idle/error reads recoverable without a tight retry loop. */
export function scoreRefreshIntervalMs(
  seconds: number | null | undefined,
): number {
  return seconds != null && seconds > 0 ? seconds * 1000 : 120_000;
}
